<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="8">
        <v-card flat>
          <v-card class="d-flex justify-space-between pr-4" flat>
            <p class="mb-0 pt-1 text-h6 ml-2">Recent Cases</p>
            <v-card class="d-flex" flat>
              <v-btn-toggle
                v-model="recentCaseFilter"
                color="primary"
                group
                dense
                class="mr-2"
                outlined
              >
                <v-btn value="personal" small> My </v-btn>
                <v-btn value="all" small> All </v-btn>
              </v-btn-toggle>
              <DialogForm
                title="Open Case"
                @click.stop
                submit-text="Open"
                :disable-submit="!caseToOpen.id"
                :submit="openCase(caseToOpen)"
                :max-width="0"
                :dialog-props="{ width: 'unset' }"
              >
                <template #activator="{ on }">
                  <v-btn rounded small outlined class="mt-1 mx-1" color="primary" v-on="on">
                    <v-icon class="mr-2"> mdi-folder-open-outline</v-icon>open case
                  </v-btn>
                </template>
                <template #default>
                  <FolderTreeSelect
                    v-model="caseToOpen"
                    show-cases
                    select-only="case"
                  ></FolderTreeSelect>
                </template>
              </DialogForm>
              <v-btn
                rounded
                small
                outlined
                class="mt-1 mx-1"
                color="primary"
                :to="{ name: 'Folders' }"
              >
                see All cases</v-btn
              >
            </v-card>
          </v-card>
          <v-divider />
          <v-card-text>
            <v-row>
              <v-col v-for="caseItem in cases" sm="4" cols="6" :key="caseItem.id">
                <v-card
                  height="100%"
                  class="d-flex flex-column"
                  @click="caseCardClick(caseItem)"
                  active
                >
                  <v-card-title>
                    <v-list-item-title class="d-flex text-wrap case-title">
                      {{ caseItem.name }}
                      <v-spacer />
                      <v-tooltip top>
                        <template #activator="{ on }">
                          <v-btn
                            icon
                            small
                            class="mt-0"
                            @click.stop
                            :to="{ name: 'Folders', params: { folderId: caseItem.directory_id } }"
                            v-on="on"
                          >
                            <v-icon>mdi-folder-open-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Open containing folder</span>
                      </v-tooltip>
                    </v-list-item-title>
                    <v-list-item-subtitle class="font-weight-light"
                      >Last modified: {{ formatDate(caseItem.updated) }}
                    </v-list-item-subtitle>
                  </v-card-title>
                  <v-card-text class="text-body-2 grow">
                    <v-tooltip right v-if="caseItem.notes.length > 80" max-width="240">
                      <template #activator="{ on }">
                        <div v-on="on">
                          {{ caseItem.notes.replace(/^(.{80}[^\s]*).*/, "$1") }}
                          <span>...</span>
                        </div>
                      </template>
                      <p>{{ caseItem.notes }}</p>
                    </v-tooltip>
                    <div v-else>{{ caseItem.notes }}</div>
                  </v-card-text>
                  <v-divider />
                  <v-card-actions class="justify-space-around">
                    <v-card
                      v-for="job in caseJobs(caseItem)"
                      :key="`job-${job.name}-case-${caseItem.id}`"
                      flat
                      color="transparent"
                    >
                      <v-tooltip top v-if="job.status !== 'NOT_STARTED'">
                        <template #activator="{ on }">
                          <v-badge :value="job.value" :color="job.color" dot>
                            <v-card flat v-on="on" @click.stop="toOutput(job)">{{
                              job.name
                            }}</v-card>
                          </v-badge>
                        </template>
                        <span>{{ job.status | snakeToHuman }}</span>
                      </v-tooltip>
                      <v-card v-else flat color="transparent">{{ job.name }}</v-card>
                    </v-card>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- <v-divider class="mt-5 mb-5" />
        <v-row class="mb-10">
          <v-col cols="12">
            <p class="mb-0 pt-1 text-h6 ml-2">Blog</p>
            <v-divider class="mb-4" />
            <v-card height="100%" class="d-flex flex-column" outlined>
              <v-list-item
                v-for="card in blogCards"
                :key="`blog-${card.link}`"
                three-line
                :href="card.link"
                target="_blank"
              >
                <v-list-item-content>
                  <v-row dense>
                    <v-col sm="2" class="text-center">
                      <v-img
                        :src="blogImgUrl(card.description)"
                        max-height="120"
                        max-width="120"
                        class="text-center"
                      />
                    </v-col>
                    <v-col sm="10">
                      <v-list-item-title class="text-wrap">
                        {{ card.title }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="text-wrap">
                        {{ blogSubtitle(card.description) }}
                      </v-list-item-subtitle>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
              <v-btn block class="px-4" text rounded href="https://acelerex.com/category/blog/">
                See all posts
              </v-btn>
            </v-card>
          </v-col>
        </v-row> -->
      </v-col>
      <v-col cols="12" sm="4">
        <v-card height="100%" class="d-flex flex-column" flat>
          <v-card class="d-flex justify-space-between" flat>
            <p class="mb-0 pt-1 text-h6">
              <v-icon>mdi-clipboard-check-multiple</v-icon> Recent Jobs
            </p>
            <v-card class="d-flex" flat>
              <v-btn-toggle
                v-model="recentJobsFilter"
                color="primary"
                group
                dense
                class="mr-6"
                outlined
              >
                <v-btn value="personal" small> My </v-btn>
                <v-btn value="all" small> All </v-btn>
              </v-btn-toggle>
              <router-link :to="{ name: 'Jobs' }">
                <p class="mb-0 pt-3 text-caption">See all jobs</p>
              </router-link>
            </v-card>
          </v-card>
          <v-divider class="mb-4" />
          <v-card v-for="job in jobsCards" :key="`job-${job.id}`" flat>
            <v-tooltip top>
              <template #activator="{ on }">
                <v-list-item dense @click="jobItemClick(job)" v-on="on">
                  <v-list-item-content>
                    <v-list-item-title>
                      <FeathersVuexGet
                        v-slot="{ item: caseItem }"
                        service="cases"
                        :id="job.case_id"
                      >
                        <span>
                          {{ caseItem ? caseItem.name : "" }}
                          <span class="text-caption height-1rem">(ID: {{ job.case_id }})</span>
                        </span>
                      </FeathersVuexGet>
                    </v-list-item-title>
                    <v-list-item-subtitle>{{ job.type_name | snakeToHuman }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-tooltip top>
                    <template #activator="{ on }">
                      <v-list-item-icon v-on="on">
                        <v-icon
                          v-if="job.status !== 'IN_PROGRESS'"
                          v-text="job.iconText"
                          :color="job.iconColor"
                        />
                        <v-progress-circular
                          v-else
                          indeterminate
                          color="secondary"
                          size="24"
                        ></v-progress-circular>
                      </v-list-item-icon>
                    </template>
                    <span>{{ job.status | snakeToHuman }}</span>
                  </v-tooltip>
                </v-list-item>
              </template>
              <span>{{ job.status === "COMPLETE" ? "See outputs" : "See job" }}</span>
            </v-tooltip>
          </v-card>
          <p class="mt-4 mb-0 text-h6"><v-icon>mdi-message-text</v-icon> Messages</p>
          <v-divider class="mb-4" />
          <v-card v-for="message in messages" :key="`message-${message.id}`" flat>
            <v-list-item dense @click="jobItemClick(job)">
              <v-list-item-content>
                <v-list-item-title>
                  {{ message.message }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  <span>{{ formatDate(message.created) }}</span> |
                  <FeathersVuexGet v-slot="{ item: job }" service="jobs" :id="message.job_id">
                    <span>{{ job ? job.type_name : "" | snakeToHuman }}</span>
                  </FeathersVuexGet>
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  <FeathersVuexGet
                    v-slot="{ item: caseItem }"
                    service="cases"
                    :id="message.case_id"
                  >
                    <span>
                      {{ caseItem ? caseItem.name : "" }}
                      <span class="text-caption height-1rem">(ID: {{ message.case_id }})</span>
                    </span>
                  </FeathersVuexGet>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
          <p class="mt-4 mb-0 text-h6"><v-icon>mdi-book-open-page-variant</v-icon> Tutorials</p>
          <v-divider class="mb-4" />
          <v-card flat>
            <v-list-item
              v-for="calculation in calculations"
              :key="calculation.title"
              :to="calculation.to"
            >
              <v-list-item-content>
                <v-list-item-title>{{ calculation.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card>
          <v-card class="d-flex flex-column mt-4" outlined>
            <v-card-title class="text-subtitle-1">
              Release: {{ currentRelease.version || "" }}
              <v-tooltip top>
                <template #activator="{ on }">
                  <v-chip color="primary" outlined x-small class="mx-2" v-on="on">
                    {{ timeFrom(currentRelease.date) }} ago
                  </v-chip>
                </template>
                <span>{{ formatDate(currentRelease.date, "DATE_SHORT") || "" }}</span>
              </v-tooltip>
            </v-card-title>
            <v-card-subtitle class="text-caption"> </v-card-subtitle>
            <v-card-text>
              <div v-html="currentRelease.html" class="markdown-index"></div>
            </v-card-text>
            <v-card-actions class="pl-6 text-caption">
              <router-link :to="{ name: 'Releases' }"> See older versions </router-link>
            </v-card-actions>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import filters from "@/mixins/filters";
import { makeFindMixin } from "feathers-vuex";
import { DateTime } from "luxon";
import MarkdownIt from "markdown-it";
import { parse } from "rss-to-json";
import { mapGetters } from "vuex";

const md = new MarkdownIt();

export default {
  name: "Homepage",
  components: {
    DialogForm: () => import("@/components/DialogForm.vue"),
    FolderTreeSelect: () => import("@/components/FolderTreeSelect.vue"),
  },
  mixins: [
    filters,
    makeFindMixin({
      service: "release-notes/app",
      name: "release-notes",
    }),
    makeFindMixin({
      service: "cases",
    }),
    makeFindMixin({
      service: "jobs",
      watch: "params",
    }),
    makeFindMixin({
      service: "messages",
    }),
  ],
  props: {},
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
      calculations: [
        {
          title: "Alternative Analysis",
          description:
            "Solves multi-year optimal capacity to meet a planning reserve margin with resources of demand response, energy efficiency, conventional fossil fuels, hydro, renewables, distributed energy resources, energy storage and others.",
          to: { name: "Wiki", params: { id: "13fb24012b6c806c81c1e63c97825e04" } },
        },
        {
          title: "Production Cost",
          description:
            "Solves multi-year optimal capacity to meet a planning reserve margin with resources of demand response, energy efficiency, conventional fossil fuels, hydro, renewables, distributed energy resources, energy storage and others.",
          to: { name: "Wiki", params: { id: "13fb24012b6c80ffb4d7d500be1b36c5" } },
        },
        {
          title: "Stacked Services Emulator",
          description:
            "Emulates hourly or sub-hourly dispatch of a project such as energy storage for delivering stacked services including Energy Arbitrage, Ancillary Services, Renewable Shifting, Peak Shaving, Frequency Response, and others.",
          to: { name: "Wiki", params: { id: "13fb24012b6c80ae9104eee04610e2ba" } },
        },
        {
          title: "Effective Load Carrying Capacity",
          description: "",
          to: { name: "Wiki", params: { id: "13fb24012b6c801cb064e2e467f9271f" } },
        },
        {
          title: "Power Flow",
          description: "",
          to: { name: "Wiki", params: { id: "13fb24012b6c809e92cbc72170df839c" } },
        },
        {
          title: "Short Circuit",
          description: "",
          to: { name: "Wiki", params: { id: "13fb24012b6c8054a66ed2bf4c80b4dc" } },
        },
        {
          title: "Transient Stability",
          description: "",
          to: { name: "Wiki", params: { id: "1d8b24012b6c8097aa28edb8bc87b5d6" } },
        },
        { title: "Load Forecast", description: "", to: { name: "Wiki" } },
      ],
      recentCaseFilter: "personal",
      recentJobsFilter: "personal",
      refreshJobsMessages: undefined,
      // blog: null,
      caseToOpen: {},
    };
  },
  computed: {
    ...mapGetters({
      findJobsGetter: "jobs/find",
    }),
    releaseNotesParams() {
      return {};
    },
    casesParams() {
      let personalJobsIds;
      if (this.recentCaseFilter === "personal") {
        const jobs = this.findJobsGetter({ query: { id: this.$auth.user.id } }).data;
        personalJobsIds = jobs.map((j) => j.case_id);
      }
      return {
        query: {
          ...(personalJobsIds ? { id: { $in: personalJobsIds } } : {}),
          $sort: { updated: -1 },
          $limit: 6,
        },
      };
    },
    casesFetchParams() {
      return {
        query: {
          updated: { $gt: new DateTime("local").minus({ months: 3 }).toISO() },
          $sort: { updated: -1 },
          $select: ["id", "name", "notes", "updated", "directory_id"],
        },
      };
    },
    jobsParams() {
      return {
        query: {
          $limit: 6,
          updated: { $gt: new DateTime("local").minus({ days: 15 }).toISO() },
          ...(this.recentJobsFilter === "personal" ? { id: this.$auth.user.id } : {}),
          $sort: { updated: -1 },
        },
      };
    },
    messagesParams() {
      return {
        query: {
          $limit: 6,
          created: { $gt: new DateTime("local").minus({ days: 1 }).toISO() },
          $sort: { created: -1 },
        },
      };
    },
    majorVersion() {
      return this.version.split(".")[0];
    },
    currentRelease() {
      if (this.releaseNotes.length) {
        const note = this.releaseNotes[0];
        const { description } = note.release;
        const htmlString = md.render(description);
        return { version: note.name, html: htmlString, date: note.date };
      }
      return { html: "<div></div>" };
    },
    jobsCards() {
      const icon = {
        NOT_STARTED: { text: "mdi-timer-sand-empty", color: "warning" },
        COMPLETE: { text: "mdi-check-circle-outline", color: "success" },
        ERROR: { text: "mdi-alert-circle-outline", color: "error" },
      };
      return this.jobs.map((j) => ({
        ...j,
        iconText: icon[j.status] ? icon[j.status].text : "",
        iconColor: icon[j.status] ? icon[j.status].color : "",
      }));
    },
    // blogCards() {
    //   return this.blog ? this.blog.items.filter((item) => item.category === "Blog") : [];
    // },
  },
  watch: {
    haveCasesLoadedOnce() {
      if (this.recentCaseFilter === "personal") {
        const jobs = this.findJobsGetter({ query: { id: this.$auth.user.id } }).data;
        const personalJobsIds = jobs.map((j) => j.case_id);
        if (!personalJobsIds.length) {
          this.recentCaseFilter = "all";
        }
      }
    },
  },
  beforeCreate() {},
  created() {
    this.fetchBlog();
  },
  beforeMount() {},
  mounted() {
    this.refreshData();
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    clearTimeout(this.refreshJobsMessages);
  },
  destroyed() {},
  methods: {
    async fetchBlog() {
      const blog = await parse("https://acelerex.com/feed/");
      this.blog = blog;
    },
    blogSubtitle(cardDescription) {
      return cardDescription.split("/>")[1];
    },
    blogImgUrl(cardDescription) {
      const img = cardDescription.slice(cardDescription.search('src="') + 5).split('"')[0];
      return `https://acelerex.com${img}`;
    },
    refreshData() {
      this.findJobs();
      this.findMessages();
      this.refreshJobsMessages = setTimeout(this.refreshData, 60 * 1000);
    },
    formatDate(date, format = "DATETIME_SHORT") {
      return date ? DateTime.fromISO(date).toLocaleString(DateTime[format]) : "";
    },
    timeFrom(date) {
      if (!date) {
        return "";
      }
      const diff = DateTime.fromISO(date).diffNow();
      if (Math.abs(diff.as("days")) > 31) {
        return `${Math.floor(Math.abs(diff.as("months")))} months`;
      }
      return `${Math.floor(Math.abs(diff.as("days")))} days`;
    },
    caseCardClick(caseItem) {
      this.$router.push({ path: `/case/${caseItem.id}` });
    },
    openCase(caseToOpen) {
      return () => {
        this.$router.push({ path: `/case/${caseToOpen.id}` });
      };
    },
    jobItemClick(job) {
      if (job.status === "COMPLETE") {
        const shortName = {
          ALTERNATIVE_ANALYSIS: "AA",
          PRODUCTION_COST: "PC",
          STACKED_SERVICES_EMULATOR: "SSE",
          ELCC: "ELCC",
          POWER_FLOW: "PF",
          SHORT_CIRCUIT: "SC",
          TRANSIENT_STABILITY: "TS",
          LOAD_FORECAST: "LF",
        };
        this.toOutput({ ...job, caseId: job.case_id, name: shortName[job.type_name] });
      } else {
        this.$router.push({ name: "Jobs" });
      }
    },
    toOutput(job) {
      if (job.status === "COMPLETE") {
        this.$router.push({ path: `/case/${job.caseId}/output`, query: { job: job.name } });
      }
    },
    caseJobs(caseItem) {
      const jobName = {
        AA: "ALTERNATIVE_ANALYSIS",
        PC: "PRODUCTION_COST",
        SSE: "STACKED_SERVICES_EMULATOR",
        ELCC: "ELCC",
        PF: "POWER_FLOW",
        SC: "SHORT_CIRCUIT",
        TS: "TRANSIENT_STABILITY",
        LF: "LOAD_FORECAST",
      };
      const color = {
        COMPLETE: "success",
        COMPLETE_WITH_WARNINGS: "warning",
        ERROR: "error",
      };
      return Object.keys(jobName).map((job) => {
        const status =
          caseItem.jobs && caseItem.jobs[jobName[job]]
            ? caseItem.jobs[jobName[job]].status
            : "NOT_STARTED";
        return {
          name: job,
          status,
          value: status !== "NOT_STARTED",
          color: color[status],
          caseId: caseItem.id,
        };
      });
    },
  },
};
</script>

<style scoped>
.height-1rem {
  line-height: 1rem !important;
}
.case-title {
  line-height: 1.5rem !important;
}
</style>
<style>
.markdown-index > h1 {
  font-size: 1.75em;
  font-weight: 600;
  margin: 04px 0 16px;
  padding-bottom: 0.3em;
  border-bottom: 1px solid #eaeaea;
}
.markdown-index > h2 {
  font-size: 1.5em;
  font-weight: 600;
  margin: 24px 0 16px;
  padding-bottom: 0.3em;
  border-bottom: 1px solid #eaeaea;
}
</style>
